import { ChangeDetectorRef, Directive, ElementRef, EventEmitter, inject, Input, NgZone, Output } from '@angular/core';

import { ScheduleNActionService } from '../../../+authenticated/+schedule/shared/schedule-actions/schedule-n-action.service';
import { DragDropConfig } from '../config/drag-drop-config';
import { DragDropData } from '../models/drag-drop-data.model';
import { DragDropService } from '../service/drag-drop/drag-drop.service';
import { isPresent } from '../util/is-present';
import { AbstractDirective } from './abstract/abstract.directive';

/* tslint:disable directive-selector no-output-on-prefix */
@Directive({ standalone: false, selector: '[dnd-droppable]' })
export class DroppableDirective extends AbstractDirective {
  @Output()
  onDropSuccess: EventEmitter<DragDropData> = new EventEmitter<DragDropData>();
  @Output()
  onDragEnter: EventEmitter<DragDropData> = new EventEmitter<DragDropData>();
  @Output()
  onDragOver: EventEmitter<DragDropData> = new EventEmitter<DragDropData>();
  @Output()
  onDragLeave: EventEmitter<DragDropData> = new EventEmitter<DragDropData>();

  hasDragActions: boolean;

  constructor() {
    const elementReference = inject(ElementRef);
    const dragDropService = inject(DragDropService);
    const config = inject(DragDropConfig);
    const cdr = inject(ChangeDetectorRef);
    const zone = inject(NgZone);
    const scheduleActionService = inject(ScheduleNActionService);

    super(elementReference, dragDropService, config, cdr, zone, scheduleActionService);

    this.dropEnabled = true;
  }

  override dragEnterCallback(event: MouseEvent): void {
    if (this.dragDropService.isDragged) {
      this.element.classList.add(this.config.onDragEnterClass);
      this.onDragEnter.emit({ dragData: this.dragDropService.dragData, mouseEvent: event });
    }
  }

  override dragOverCallback(event: MouseEvent): void {
    if (this.dragDropService.isDragged) {
      this.element.classList.add(this.config.onDragOverClass);
      this.onDragOver.emit({ dragData: this.dragDropService.dragData, mouseEvent: event });
    }
  }

  override dragLeaveCallback(event: MouseEvent): void {
    if (this.dragDropService.isDragged) {
      this.onDragLeave.emit({ dragData: this.dragDropService.dragData, mouseEvent: event });
    }
  }

  override dropCallback(event: MouseEvent): void {
    const dataTransfer = (event as any).dataTransfer;

    if (this.dragDropService.isDragged || (isPresent(dataTransfer) && isPresent(dataTransfer.files))) {
      this.onDropSuccess.emit({ dragData: this.dragDropService.dragData, mouseEvent: event });

      if (isPresent(this.dragDropService.onDragSuccessCallback)) {
        this.dragDropService.onDragSuccessCallback.emit({ dragData: this.dragDropService.dragData, mouseEvent: event });
      }

      this.element.classList.remove(this.config.onDragOverClass);
      this.element.classList.remove(this.config.onDragEnterClass);
    }
  }
}
